module.exports = __webpack_public_path__ + "static/media/gray_logo.de930884.png";